export default __webpack_public_path__ + "static/media/features-thumb-2p.c442c6c4.png";